import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const InfrastructureManagement = () => {
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  return (
    <section className="min-h-screen bg-blue-950 py-16 px-6 sm:px-10 lg:px-20" style={{backgroundImage:`url(/servicepages/serversetup-bg.jpg)`}}>
      <div className="max-w-7xl mx-auto space-y-16">
        {/* Hero */}
        <div data-aos="fade-up" className="text-center">
          <h2 className="text-4xl font-bold font-poppins text-sky-400">
            Infrastructure Management
          </h2>
          <p className="text-lg text-white mt-4 font-inter">
            We design, deploy, and manage secure server infrastructure that ensures seamless business operations with maximum uptime and performance.
          </p>
        </div>

        {/* Section 1 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center text-justify" data-aos="fade-right">
          <img
            src="/servicepages/server-racks.jpg"
            alt="Server Racks"
            className="w-full h-auto rounded-lg shadow-md object-cover"
          />
          <div className="space-y-4">
            <h3 className="text-2xl font-semibold text-sky-400 font-poppins">
              Full Infrastructure Support
            </h3>
            <p className="text-white font-inter">
              Whether you're setting up servers from scratch or expanding your current infrastructure, we deliver end-to-end support for on-premise, hybrid, or cloud-based environments.
            </p>
            <p className="text-white font-inter">
              Our team handles procurement, physical setup, OS installation, network integration, and security hardening to ensure each server is tailored to your workload needs.
            </p>
            <p className="text-white font-inter">
              We ensure high availability configurations, virtualization setups, and redundancy planning are aligned with your business continuity goals.
            </p>
          </div>
        </div>

        {/* Section 2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center text-justify" data-aos="fade-left">
          <div className="space-y-4">
            <h3 className="text-2xl font-semibold text-sky-400 font-poppins">
              Monitoring & Backup Solutions
            </h3>
            <p className="text-white font-inter">
               Continuous supervision of IT systems and the implementation of robust data backup strategies to ensure business continuity.
            </p>
            <p className="text-white font-inter">
              We provide real-time tracking of server performance, network activity, and system health to proactively detect and resolve issues before they escalate. Simultaneously, automated and secure backup solutions are configured to safeguard critical data from loss due to hardware failures, cyber-attacks, or human error.
            </p>
            <p className="text-white font-inter">
             Solutions are crucial for maintaining operational , compliance requirements, and enabling quick disaster recovery without impacting productivity.
            </p>
          </div>
          <img
            src="/servicepages/backup.png"
            alt="Server Monitoring"
            className="w-full h-auto rounded-lg shadow-md object-cover"
          />
        </div>

        

        {/* CTA */}
        <div className="text-center">
          <a
            href="/contact"
            className="inline-block bg-gray-50 text-blue-950 px-8 py-3 rounded-md font-semibold hover:text-sky-400 transition"
          >
            Talk to Our Experts
          </a>
        </div>
      </div>
    </section>
  );
};

export default InfrastructureManagement;
